var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0123 0.00357408C12.832 0.0201973 12.6622 0.0960076 12.5297 0.21931L0.258932 11.6732C0.0931295 11.8285 -0.000544543 12.0455 2.38159e-06 12.2725V14.7309C0.000915371 14.9468 0.0871039 15.1536 0.239757 15.3064C0.392227 15.4591 0.599114 15.5453 0.814962 15.546H3.2722C3.47835 15.5462 3.67683 15.4686 3.82823 15.3286L16.099 3.86819C16.2613 3.71639 16.355 3.50522 16.3584 3.28308C16.3619 3.06094 16.275 2.84686 16.1176 2.69011L13.6665 0.238278C13.4943 0.0667474 13.2542 -0.0190784 13.0123 0.00357408ZM13.0681 1.95359L14.3655 3.25311L2.94649 13.9097H1.63635V12.6295L13.0681 1.95359Z",
    fill: "#3886F7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.b339b7d852499268c09ff49aedd1b00b.svg";